import { render, staticRenderFns } from "./ImageTypeSwitcher.vue?vue&type=template&id=3f5356ef&scoped=true&"
import script from "./ImageTypeSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ImageTypeSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ImageTypeSwitcher.vue?vue&type=style&index=0&id=3f5356ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5356ef",
  null
  
)

export default component.exports